import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserModule } from '@portal/entity-services/users/src/lib/user.module';
import { ChangePasswordPageComponent } from './change-password-page.component';

@NgModule({
  declarations: [ChangePasswordPageComponent],
  imports: [CommonModule, UserModule],
})
export class ChangePasswordPageModule {}
